import {
  GET_TRIBUN_LAST_WIN_LOST_COUPONS_REQUEST,
  GET_TRIBUN_LAST_WIN_LOST_COUPONS_SUCCESS,
  GET_TRIBUN_LAST_WIN_LOST_COUPONS_FAILURE,
} from 'Store/constants';
  
const initailState = {
  data: [],
  isLoading: false,
  error: null
};
  
export default (state = initailState, action ) => {
  switch (action.type) {
    case GET_TRIBUN_LAST_WIN_LOST_COUPONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_TRIBUN_LAST_WIN_LOST_COUPONS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_TRIBUN_LAST_WIN_LOST_COUPONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};